export default "__VITE_ASSET__9ca60deb__"